enum DeliveryMethod {
    MOBILE_DELIVERY = "MOBILE_DELIVERY",
    E_TICKET = "E_TICKET",
    PHYSICAL = "PHYSICAL",
    PAPERLESS = "PAPERLESS",
    UNRECOGNIZED = "UNRECOGNIZED"
}

export default DeliveryMethod;